<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.orderTags.ordersTags') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
        </d-button>
        <d-button theme="success" @click.prevent="$router.push('/ustawienia/tagi-zamowien/nowy')">
          <i class="material-icons">add</i>
          {{ $t('settings.orderTags.addNewOrderTag') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0" style="width: 24px;"></th>
            <th scope="col" class="border-0">{{ $t('settings.orderTags.tagNameAndDescription') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.orderTags.taggedOrders') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(tag, index) of tags"
            :key="'tag-' + index">
            <td class="align-middle pr-0">
              <div :style="'background-color: ' + tag.color + '; width: 24px; height: 24px; border-radius: 50%;'"></div>
            </td>
            <td class="align-middle">
              {{ tag.name }}<br>
              <small v-if="tag.description">
                {{ tag.description }}
              </small>
            </td>
            <td class="align-middle">
              {{ tag.orders_count }}
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/ustawienia/tagi-zamowien/edycja/' + tag.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                @click.native="removeTag(tag.id)"
                :disabled="removeInProgress"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="tags.length === 0">
            <td
              colspan="3"
              class="text-center">
              {{ $t('settings.orderTags.noTagsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'order-tags',
  data() {
    return {
      tags: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/orders/tags/items', 'tags', {}, 'get');
    },
    removeTag (tagID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/orders/tags/delete/',
        id: tagID,
        successTitle: this.$t('settings.orderTags.removeTagSuccessTitle'),
        successText: this.$t('settings.orderTags.removeTagSuccessText'),
        confirmTitle: this.$t('settings.orderTags.removeTagConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.orderTags.removeTagErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
